const _ = require('underscore');
const React = require("react");
const createReactClass = require("create-react-class");

const form = require('../../../deploynaut/js/Form.jsx');

const NewRelicAPMForm = createReactClass({
	getInitialState: function() {
		const state = {
			id: null,
			apiKey: "",
			appID: ""
		};

		const integration = this.props.integration;
		if (integration && integration.options !== undefined) {
			state.id = integration.id;
			state.apiKey = integration.options.APIKey;
			state.appID = integration.options.AppID;
		}

		return state;
	},

	render() {
		return (
			<div className="integration-form">
				<p>
					<a href="https://docs.newrelic.com/docs/apm" target="_new">New Relic APM</a> can track your recent deployments
					and identify the performance impact to your users and your stack's Apdex score.
				</p>
				<p>Deployment Tracking requires the Pro edition of New Relic APM.</p>

				<form.Form
					ref="newrelicapmForm"
					url={this.props.model.UpdateURL}
					securityID={this.props.model.InitialSecurityID}
					buttonTitle="Save"
					buttonSubmittingTitle="Saving"
					afterSuccess={this.props.afterSuccess}
				>
					<div className="form-group">
						<label htmlFor="APIKey">API Key</label>
						<form.Input
							name="APIKey"
							required
							validationError="Please enter a valid API key for your New Relic account"
							placeholder="API Key"
							value={this.state.apiKey}
						/>
					</div>
					<div className="form-group">
						<label htmlFor="AppID">Application ID</label>
						<form.Input
							name="AppID"
							required
							validationError="Please enter a valid Application ID belonging to your New Relic application"
							placeholder="Application ID"
							value={this.state.appID}
						/>
					</div>

					<form.Hidden name="Type" value="NewRelicAPM" />
					<form.Hidden name="ID" value={this.state.id} />
				</form.Form>
			</div>
		);
	}
});

module.exports = NewRelicAPMForm;

